var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('BasicNavigation',{attrs:{"header-image":"header_tiketing.png"}}),_c('v-flex',{attrs:{"text-xs-center":"","pt-3":""}},[_c('h1',[_vm._v("Pembelian Tiket untuk Group (Sekolah)")])]),_c('KelompokList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }